import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from "axios";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";

// layouts

import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout

import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";
import Tables from "@/views/admin/Tables.vue";
import Maps from "@/views/admin/Maps.vue";

// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Download from "@/views/Download.vue";

// views without layouts

import Blast from "@/views/Blast.vue";
import Gene_expression from "@/views/Gene_expression.vue";
import Rna_seqid from "@/views/Rna_seqid.vue";
import Index from "@/views/Index.vue";
import Annotation from "@/views/ALL_annotation.vue";
import Conserved_motif from "@/views/Conserved_motif";
import Phylogenetic_tree from "@/views/Phylogenetic_tree";
import Pathway from "@/views/Pathway";
import Protein from "@/views/Protein";
import Differential_expression from "@/views/Differential_expression";
// routes

const routes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: Admin,
    children: [
      {
        path: "/admin/dashboard",
        component: Dashboard,
      },
      {
        path: "/admin/settings",
        component: Settings,
      },
      {
        path: "/admin/tables",
        component: Tables,
      },
      {
        path: "/admin/maps",
        component: Maps,
      },
    ],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
      },
    ],
  },
  {
    path: "/gene_expression",
    component: Gene_expression,
  },
  {
    path: "/",
    component: Index,
  },
    {
    path: "/blast",
    component: Blast,
  },
    {
    path: "/rna_seqid",
    component: Rna_seqid,
  },
    {
        path: "/download",
        component: Download,
      },
    {
        path: "/annotation",
        component: Annotation,
      },
    {
        path: "/conserved_motif",
        component: Conserved_motif,
      },
    {
        path: "/phylogenetic_tree",
        component: Phylogenetic_tree,
      },
    {
        path: "/pathway",
        component: Pathway,
      },
    {
        path: "/psd",
        component: Protein,
      },
    {
        path: "/differential_expression",
        component: Differential_expression
      },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  base:"/CinnamomumPlants",
  history: createWebHistory(),
  routes,
});
createApp(App).use(router).use(ElementPlus).provide('$axios',axios).mount("#app");
